
import { IonApp } from '@ionic/vue'

export default {
  components: {
    IonApp,
  },
}
